import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  label?: string;
}

export function LoadingSpinner({ className, label }: LoadingSpinnerProps) {
  const { t } = useTranslation('common');
  const resolvedLabel = label === undefined ? t('loading.label') : label;

  return (
    <div
      className={cn(
        'rounded-full border-2 border-zoovpalelavender border-t-zooprimary animate-spin',
        className
      )}
      role="status"
    >
      <span className="sr-only">{resolvedLabel}</span>
    </div>
  );
}
